import { BrowserRouter } from "react-router-dom";
// import cn from "classnames";
// import { Provider } from "react-redux";

import "./assets/styles/index.scss";
import Router from "./router";
//import "bootstrap/scss/bootstrap.scss";
//import "bootstrap/scss/_accordion.scss";
// import "../assets/styles/bootstrap/bootstrap.min.css";
// import "../assets/styles/bootstrap/_variables.scss";
// import { store } from "../../redux/store/configure-store";
// import "../../assets/style/common.sass";
// import "../../assets/style/font.sass";
// import "../../assets/style/v-app.sass";
// import "../../assets/style/media.sass";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";


const App = () => {
  // const [isHidden, setIsHidden] = useState(true);


  // if (isHidden) {
  //     return null;
  // }

  return (
      <BrowserRouter>
        <Router />
      </BrowserRouter>
  );
};



export default App;
